module.exports = __webpack_public_path__ + "static/img/TD.fc336a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TD.png
// module id = fbN3
// module chunks = 1